var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"slider-section"},[_c('VueSlickCarousel',_vm._b({},'VueSlickCarousel',_vm.settings,false),_vm._l((_vm.items),function(item,i){return _c('a',{key:i,attrs:{"href":item.url}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.image),expression:"item.image"}],attrs:{"title":item.name,"alt":item.name}})])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }